import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WorkflowExecutionService } from 'app/services/workflow-execution.service';
import { WorkflowExec } from 'app/models/workflow-exec';
import { finalize } from 'rxjs/operators';
import { FormGroup } from '@angular/forms';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { StepCompletionExecution } from 'app/models/step-completion-execution';
import { MDBModalService, ToastService } from 'ng-uikit-pro-standard';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';
import { WorkflowStep } from 'app/models/workflow-step';
import { FeatureTrialLockModalComponent } from 'app/views/feature-trial-lock-modal/feature-trial-lock-modal.component';
import { UserService } from 'app/services/user.service';

@Component({
  selector: 'app-complete-workflow-task',
  templateUrl: './complete-workflow-task.component.html',
  styleUrls: ['./complete-workflow-task.component.scss']
})
export class CompleteWorkflowTaskComponent implements OnInit {

  workflowExec: WorkflowExec = null;

  isLoading: boolean = true;
  isTaskCompleted: boolean = false;

  errorMsg: string = null;

  constructor(private activatedRoute: ActivatedRoute, private workflowExecutionService: WorkflowExecutionService,
              private workflowTemplateService: WorkflowTemplateService, private toastService: ToastService, private ecoDocsTitleService: EcoDocsTitleService,
              private userService: UserService, private modalService: MDBModalService) {
    this.activatedRoute.params.subscribe(params => {
      const stepId: number = +params['stepId'];
      const execId: number = +params['execId'];

      this.isLoading = true;
      this.workflowExecutionService.getCurrentTask(execId, stepId).pipe(finalize(() => {
        this.isLoading = false;
      })).subscribe((w) => {
        this.workflowExec = w;
        this.ecoDocsTitleService.setTitle(w.current_step.name, false);
      }, (err) => {
        if (err.status == 422 && err.message) {
          this.errorMsg = err.message;
        } else if (err.status == 403) {
          this.errorMsg = "This task either doesn't exist or you don't have access to it."
        }
      });
    });
  }

  ngOnInit(): void {
  }

  onCompleted(stepCompletionExecution: StepCompletionExecution) {
    if (!this.userService.currentUserValue.subscription_status.is_subscribed &&
      !this.userService.currentUserValue.subscription_status.trial_active) {
        this.modalService.show(FeatureTrialLockModalComponent, {
          ignoreBackdropClick: true,
          backdrop: false,
          animated: true,
          containerClass: 'modal fade',
          class: 'modal-dialog modal-danger modal-notify',
          data: {
          }
        });
        return;
    }

    this.isLoading = true;
    this.workflowExecutionService.completeStep(this.workflowExec.id, stepCompletionExecution).pipe(finalize(() => {
      this.isLoading = false;
    })).subscribe(() => {
      this.isTaskCompleted = true;
    }, (error) => {
      /** @todo handle error */
      if (error.errors && error.errors['step_completion_exec.password']) {
        this.toastService.error('Incorrect password!');
      } else if (error.status == 422 && error.message) {
        this.errorMsg = error.message;
      } else if (error.status == 403) {
        this.errorMsg = "This task has been completed, doesn't exist, or you don't have access to it."
      }
    });
  }
}
